<template>
<svg version="1.1" id="Layer_2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 271.2 210.7" style="enable-background:new 0 0 271.2 210.7;" xml:space="preserve">
<polyline data-async data-duration="10" data-delay="0" class="st0" points="62.8,76.6 62.8,18.2 209.3,18.2 209.3,118.3 123.7,118.3 "/>
<g>
	<path data-async data-duration="10" data-delay="0" class="st1" d="M116.9,118.2"/>
	<path data-async data-duration="10" data-delay="0" class="st1" d="M72,118.2"/>
</g>
<circle data-async data-duration="10" data-delay="0" class="st2" cx="67.4" cy="154.6" r="11.4"/>
<circle data-async data-duration="10" data-delay="0" class="st2" cx="112.4" cy="154.6" r="11.4"/>
<circle data-async data-duration="10" data-delay="0" class="st2" cx="157.3" cy="154.6" r="11.4"/>
<circle data-async data-duration="10" data-delay="0" class="st2" cx="202.2" cy="154.6" r="11.4"/>
<circle data-async data-duration="10" data-delay="0" class="st2" cx="85.2" cy="88" r="11.4"/>
<path data-async data-duration="10" data-delay="0" class="st2" d="M62.8,118.3L62.8,118.3c0-10.5,8.5-18.9,18.9-18.9h7.1c10.5,0,18.9,8.5,18.9,18.9v0"/>
<path data-async data-duration="10" data-delay="0" class="st2" d="M45,184.9L45,184.9c0-10.5,8.5-18.9,18.9-18.9H71c10.5,0,18.9,8.5,18.9,18.9v0"/>
<path data-async data-duration="10" data-delay="0" class="st2" d="M89.9,184.9L89.9,184.9c0-10.5,8.5-18.9,18.9-18.9h7.1c10.5,0,18.9,8.5,18.9,18.9v0"/>
<path data-async data-duration="10" data-delay="0" class="st2" d="M134.8,184.9L134.8,184.9c0-10.5,8.5-18.9,18.9-18.9h7.1c10.5,0,18.9,8.5,18.9,18.9v0"/>
<path data-async data-duration="10" data-delay="0" class="st2" d="M179.7,184.9L179.7,184.9c0-10.5,8.5-18.9,18.9-18.9h7.1c10.5,0,18.9,8.5,18.9,18.9v0"/>
<line data-async data-duration="10" data-delay="0" class="st2" x1="35.6" y1="184.9" x2="236.4" y2="184.9"/>
<line data-async data-duration="10" data-delay="0" class="st0" x1="153" y1="84.8" x2="191.4" y2="84.8"/>
<line data-async data-duration="10" data-delay="0" class="st0" x1="153" y1="96" x2="174.4" y2="96"/>
<polyline data-async data-duration="10" data-delay="0" class="st0" points="113.6,77.9 123.7,69.2 137.7,75.1 157.7,53.9 170.9,59.7 191.4,38.1 176.6,39.7 "/>
<line data-async data-duration="10" data-delay="0" class="st0" x1="191.4" y1="38.1" x2="191.4" y2="51.9"/>
</svg>

  <!-- <svg version="1.1" id="Layer_2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  viewBox="0 0 271.2 210.7" style="enable-background:new 0 0 271.2 210.7;" xml:space="preserve">
    <circle data-async data-duration="10" data-delay="0" class="st0" cx="244.9" cy="181.9" r="6.2"/>
    <circle data-async data-duration="10" data-delay="0" class="st0" cx="216.9" cy="181.9" r="6.2"/>
    <circle data-async data-duration="10" data-delay="0" class="st0" cx="188.8" cy="181.9" r="6.2"/>
    <circle data-async data-duration="10" data-delay="0" class="st0" cx="160.7" cy="181.9" r="6.2"/>
    <circle data-async data-duration="10" data-delay="0" class="st0" cx="132.7" cy="181.9" r="6.2"/>
    <circle data-async data-duration="10" data-delay="0" class="st0" cx="9" cy="181.9" r="6.2"/>
    <circle data-async data-duration="10" data-delay="0" class="st0" cx="9" cy="201.8" r="6.2"/>
    <circle data-async data-duration="10" data-delay="0" class="st0" cx="9" cy="161.9" r="6.2"/>
    <circle data-async data-duration="10" data-delay="0" class="st0" cx="9" cy="122" r="6.2"/>
    <circle data-async data-duration="10" data-delay="0" class="st0" cx="9" cy="142" r="6.2"/>
    <circle data-async data-duration="10" data-delay="0" class="st0" cx="9" cy="102.1" r="6.2"/>
    <circle data-async data-duration="10" data-delay="0" class="st0" cx="9" cy="82.1" r="6.2"/>
    <circle data-async data-duration="10" data-delay="0" class="st0" cx="244.9" cy="102.1" r="6.2"/>
    <circle data-async data-duration="10" data-delay="0" class="st0" cx="216.9" cy="102.1" r="6.2"/>
    <circle data-async data-duration="10" data-delay="0" class="st0" cx="188.8" cy="102.1" r="6.2"/>
    <circle data-async data-duration="10" data-delay="0" class="st0" cx="160.7" cy="102.1" r="6.2"/>
    <circle data-async data-duration="10" data-delay="0" class="st0" cx="132.7" cy="102.1" r="6.2"/>
    <circle data-async data-duration="10" data-delay="0" class="st0" cx="104.6" cy="102.1" r="6.2"/>
    <polyline data-async data-duration="10" data-delay="5" class="st0" points="216.9,175.7 216.9,161.9 15.1,161.9 "/>
    <polyline data-async data-duration="10" data-delay="5" class="st0" points="188.8,108.2 188.8,122 15.1,122 "/>
    <line data-async data-duration="10" data-delay="5" class="st0" x1="15.1" y1="102.1" x2="98.4" y2="102.1"/>
    <polyline data-async data-duration="10" data-delay="5" class="st0" points="244.9,108.2 244.9,142 15.1,142 "/>
    <line data-async data-duration="10" data-delay="5" class="st0" x1="15.1" y1="181.9" x2="126.5" y2="181.9"/>
    <polyline data-async data-duration="10" data-delay="5" class="st0" points="15.1,201.8 244.9,201.8 244.9,188 "/>
    <polyline data-async data-duration="10" data-delay="5" class="st0" points="15.1,82.1 216.9,82.1 216.9,95.9 "/>
    <g>
      <g>
        <path data-async data-duration="0" data-delay="0" class="st1" d="M268.7,26.3c0,4.3-1.1,8.3-3.1,11.8c-0.3,0.6-0.7,1.1-1.1,1.7c-0.4,0.5-0.8,1.1-1.2,1.6
          c-0.1,0.2-0.3,0.3-0.4,0.5c-0.2,0.3-0.5,0.5-0.7,0.8c-3.3,4-5,8.8-5.2,13.7c-3.3,2.5-7.5,4.1-11.9,4.1c-4.5,0-8.8-1.6-12.1-4.2
          c-0.2-3.6-1.2-7.2-3.1-10.4c-0.3-0.5-0.6-1.1-1-1.6c-0.4-0.5-0.7-1-1.1-1.5c-0.2-0.3-0.4-0.5-0.7-0.8c-0.1-0.1-0.2-0.2-0.3-0.4
          c0,0,0,0,0,0c0,0,0,0-0.1,0c-0.4-0.5-0.8-1-1.2-1.6c-0.4-0.5-0.7-1.1-1.1-1.7c-0.6-1.1-1.2-2.2-1.6-3.4c-0.1-0.3-0.2-0.7-0.3-1
          c-0.8-2.3-1.2-4.8-1.2-7.4c0-0.8,0-1.6,0.1-2.4c0-0.4,0.1-0.8,0.1-1.2c0,0,0,0,0,0l0.7-3.2c0-0.1,0.1-0.2,0.1-0.3
          c0.1-0.4,0.2-0.7,0.4-1c0.1-0.4,0.3-0.7,0.4-1.1c0,0,0,0,0-0.1c0.1-0.3,0.3-0.6,0.4-1c0,0,0,0,0-0.1c0.1-0.3,0.3-0.6,0.4-0.8
          c0-0.1,0.1-0.2,0.2-0.3l1.8-2.7c0,0,0,0,0,0c4.3-5.8,11.2-9.5,19-9.5s14.7,3.7,19,9.5c0,0,0,0,0,0c0.4,0.6,0.9,1.2,1.3,1.9
          c0.2,0.3,0.3,0.6,0.5,0.9c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.3,0.3,0.6,0.4,0.8c0,0,0,0,0,0.1c0.2,0.3,0.3,0.6,0.4,1c0,0,0,0.1,0,0.1
          c0.1,0.4,0.3,0.7,0.4,1.1c0.1,0.3,0.2,0.7,0.4,1c0,0.1,0.1,0.2,0.1,0.3c0.1,0.3,0.2,0.6,0.2,0.9c0.1,0.4,0.2,0.8,0.3,1.2
          c0.1,0.4,0.1,0.8,0.2,1.1v0c0.1,0.4,0.1,0.8,0.1,1.2C268.7,24.6,268.7,25.5,268.7,26.3z"/>
        <path data-async data-duration="0" data-delay="0" class="st1" d="M222.1,20.3c0.1-0.3,0.2-0.6,0.2-0.9l-0.7,3.2c0.1-0.4,0.1-0.8,0.2-1.1C221.9,21.1,222,20.7,222.1,20.3z"/>
        <path data-async data-duration="0" data-delay="0" class="st1" d="M226,12.1l-1.8,2.7c0.1-0.3,0.3-0.6,0.5-0.9C225.1,13.3,225.5,12.7,226,12.1z"/>
        <path data-async data-duration="0" data-delay="0" class="st1" d="M222.8,34.7c-1-2.6-1.5-5.4-1.5-8.4c0-0.8,0-1.6,0.1-2.4c-0.1,0.8-0.1,1.6-0.1,2.4
          C221.3,29.2,221.8,32.1,222.8,34.7z"/>
        <path data-async data-duration="0" data-delay="0" class="st1" d="M222.3,19.5l-0.7,3.2c0.1-0.4,0.1-0.8,0.2-1.1c0.1-0.4,0.2-0.8,0.3-1.2C222.1,20,222.2,19.7,222.3,19.5z"/>
        <path data-async data-duration="0" data-delay="0" class="st1" d="M223.2,17.1c-0.1,0.4-0.3,0.7-0.4,1.1"/>
        <path data-async data-duration="0" data-delay="0" class="st1" d="M226,12.1l-1.8,2.7c0.1-0.3,0.3-0.6,0.5-0.9C225.1,13.3,225.5,12.7,226,12.1z"/>
        <path data-async data-duration="0" data-delay="0" class="st1" d="M226.6,11.3c-0.2,0.2-0.4,0.5-0.6,0.8"/>
        <path data-async data-duration="0" data-delay="0" class="st1" d="M257,56.3C257,56.3,257,56.3,257,56.3"/>
        <path data-async data-duration="0" data-delay="0" class="st1" d="M233,56.1C232.9,56.1,232.9,56.1,233,56.1"/>
        <path data-async data-duration="0" data-delay="0" class="st2" d="M268.7,26.3c0,4.3-1.1,8.3-3.1,11.8c-0.3,0.6-0.7,1.1-1.1,1.7c-0.4,0.5-0.8,1.1-1.2,1.6
          c-0.1,0.2-0.3,0.3-0.4,0.5c-0.2,0.3-0.5,0.5-0.7,0.8c-3.3,4-5,8.8-5.2,13.7c-3.3,2.5-5.4,4.4-10.1,4c0.2-4.8,2.3-13.6,5.6-17.6
          c0.2-0.3,0.4-0.5,0.7-0.8c0.1-0.2,0.3-0.3,0.4-0.5c0.4-0.5,0.8-1,1.2-1.6c0.4-0.5,0.7-1.1,1.1-1.7c2-3.5,3.1-7.5,3.1-11.8
          c0-0.8,0-1.6-0.1-2.4c0-0.4-0.1-0.8-0.1-1.2v0c-0.1-0.4-0.1-0.8-0.2-1.2c-0.1-0.4-0.2-0.8-0.3-1.1c-0.1-0.3-0.2-0.6-0.2-0.9
          c0-0.1,0-0.2-0.1-0.3c-0.1-0.4-0.2-0.7-0.4-1c-0.1-0.4-0.3-0.7-0.4-1.1c0,0,0,0,0-0.1c-0.1-0.3-0.3-0.6-0.4-1c0,0,0,0,0-0.1
          c-0.1-0.3-0.3-0.6-0.4-0.8c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.3-0.3-0.6-0.5-0.9c-0.4-0.6-0.8-1.3-1.3-1.9c0,0,0,0,0,0
          c-3.4-4.5-8.4-7.8-14.1-9c1.6-0.3,3.2-0.5,4.9-0.5c7.8,0,14.7,3.7,19,9.5c0,0,0,0,0,0c0.5,0.6,0.9,1.2,1.3,1.9
          c0.2,0.3,0.3,0.6,0.5,0.9c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.3,0.3,0.5,0.4,0.8c0,0,0,0,0,0.1c0.2,0.3,0.3,0.6,0.4,1c0,0,0,0.1,0,0.1
          c0.1,0.4,0.3,0.7,0.4,1.1c0.1,0.3,0.2,0.7,0.4,1c0,0.1,0.1,0.2,0.1,0.3c0.1,0.3,0.2,0.6,0.2,0.9c0.1,0.4,0.2,0.8,0.3,1.1
          c0.1,0.4,0.1,0.8,0.2,1.2v0c0.1,0.4,0.1,0.8,0.1,1.2C268.7,24.6,268.7,25.5,268.7,26.3z"/>
      </g>
      <g>
        <path data-async data-duration="10" data-delay="5" class="st3" d="M244.9,2.6c-13.1,0-23.7,10.6-23.7,23.7c0,5.7,2,11,5.4,15.1c0.1,0.2,0.3,0.3,0.4,0.5
          c3.7,4.2,5.6,9.3,5.9,14.5"/>
        <path data-async data-duration="10" data-delay="5" class="st3" d="M263.3,11.3c3.3,4.1,5.3,9.3,5.3,14.9c0,5.7-2,11-5.4,15.1c-0.1,0.2,0,0,0,0c-0.1,0.2-0.2,0.3-0.4,0.5
          c-3.7,4.2-5.6,9.3-5.8,14.5"/>
        <path data-async data-duration="10" data-delay="5" class="st3" d="M255.6,16.5c2.1,2.6,3.4,5.9,3.4,9.6c0,3.7-1.3,7-3.5,9.7c-0.1,0.1,0,0,0,0"/>
        <path data-async data-duration="10" data-delay="5" class="st3" d="M257,57.2c-3.4,2.6-7.5,4.1-12.1,4.1c-4.4,0-8.5-1.4-11.9-3.9"/>
        <path data-async data-duration="10" data-delay="5" class="st3" d="M257,76.7c-3.4,2.6-7.5,4.1-12.1,4.1c-4.4,0-8.5-1.4-11.9-3.9"/>
        <path data-async data-duration="10" data-delay="5" class="st3" d="M257,67c-3.4,2.6-7.5,4.1-12.1,4.1c-4.4,0-8.5-1.4-11.9-3.9"/>
      </g>
    </g>
  </svg> -->
</template>

<script>
import Vivus from 'vivus';

export default {
  name: 'AboutGraphicTwo',
  data () {
    return {
      locations: {},
      activeLocation: null,
    }
  },
  mounted: function() {
    new Vivus('Layer_2', { duration: 400, type: "scenario-sync" }); // duration is in FRAMES, not milliseconds
  }
}
</script>

<style lang="scss" scoped>
@import "~bulma/sass/utilities/_all";
@import "../assets/sass/colors.scss";


.st0{fill:none;stroke:#2ABDC0;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
.st1{fill:#96A8D6;}
.st2{fill:none;stroke:#1B1D4C;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}

svg {
  max-width: 600px;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
